// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__3lBX0","slick-next":"CustomSlider_slick-next__Vg-7j"};